export default __webpack_public_path__ + "static/images/google-play-badge-57334eb318915db0471037a9e343b3d7.jpg";